import { adminRequests } from 'api/request';
import urls from 'configs/urls';

export const getCompanyProfile = ({ profileKey }) =>
  adminRequests.get(null, false, `${urls.profilesUrls.getCompanyProfile}/${profileKey}`);

export const updateProfileData = ({ data, profileKey }) =>
  adminRequests.patch(null, false, `${urls.profilesUrls.updateProfileData}/${profileKey}`, data);
